export default __webpack_public_path__ + "static/media/first-overlap-producer.da257cab.png";